import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Customer} from '../../../domain/customer';

@Component({
  selector: 'sg-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent {

  @Input() customer: Customer;
  @Output() orderConfirmationChange = new EventEmitter();


  closePopover() {
    this.orderConfirmationChange.emit(null);
  }

}
